import { render, staticRenderFns } from "./zoo.vue?vue&type=template&id=927e3962&scoped=true"
import script from "./zoo.vue?vue&type=script&lang=ts"
export * from "./zoo.vue?vue&type=script&lang=ts"
import style0 from "./zoo.vue?vue&type=style&index=0&id=927e3962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927e3962",
  null
  
)

export default component.exports